export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};


export const checkSamePassword = ( password1, password2) => {
  
    var validObj = {
        isValid: false,
        isValidMessage:''
    }

    if (password1.trim() !== ''){
            if ( password1 !== password2 ){
                validObj.isValid =false
                validObj.isValidMessage ="Password not matching"
                return validObj;
            }
        
    }else{
        validObj.isValid =false
        validObj.isValidMessage ="Cannot be empty"
        return validObj;
    }

}

export const checkVague = (value) =>{
    var blacklist = ["fuck","Fuck","FUCK","FUck", "FUCk","Shit", "shit", "shitty"];
    if(typeof(value) != "number" ) {
        if (value != ''){
            for (var i=0; i < blacklist.length; i++) {
                value = value.replace(blacklist[i], "****!");
            }
            return value;
        }
    }else{
        return value;
    }
    
    
}
export const checkValidity = ( value, rules ) => {
    var validObj = {
        isValid: false,
        isValidMessage:''
    }
    if ( !rules ) {
        validObj.isValid = true
        return validObj;
    }

    if(value == undefined  ){
        validObj.isValid =false
        validObj.isValidMessage = "please select a value"
        return validObj;
    }
    if(!rules.required){
        validObj.isValid = true
        return validObj;
    }
    if ( rules.minLength != undefined || value.trim() !== '') {
       
        if ( value.length >= rules.minLength ){
            
            validObj.isValid = true

            if ( rules.isAlphabet ) {
                const pattern = /^[a-zA-Z ]*$/;
                //isValid = pattern.test( value ) && isValid
        
                if ( pattern.test( value ) ){
                    validObj.isValid =true
                    return validObj;
                }else{
                    validObj.isValid =false
                    validObj.isValidMessage ="Please enter text only"
                    return validObj;
                }
        
                
            }
            if ( rules.isDiscription ) {
                const pattern = /^\s*(.*?)\s+/;
                //isValid = pattern.test( value ) && isValid
                if ( value.match( /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi ) ){
                    validObj.isValid =false
                    validObj.isValidMessage = "Please remove any email address"
                    return validObj;
                }else{
                    validObj.isValid =true
                    return validObj;
                }
        
                
            }


            

            if ( rules.isNumeric ) {
                const pattern = /^\d+$/;
                //isValid = pattern.test( value ) && isValid
        
                if ( pattern.test( value ) ){
                    validObj.isValid =true
                    return validObj;
                }else{
                    validObj.isValid =false
                    validObj.isValidMessage ="Please enter valid number"
                    return validObj;
                }
        
                
            }


            if ( rules.isEmail ) {
                const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
                if ( pattern.test( value ) ){
                    validObj.isValid =true
                    return validObj;
                }else{
                    validObj.isValid =false
                    validObj.isValidMessage ="Invalid email address"
                    return validObj;
                }
        
            }

           return validObj;
        }else{
            let txtinfor;
            validObj.isValid =false
            if (rules.minLength > 1){
                txtinfor = "characters"
            }else{
                txtinfor = "character"
            }
            validObj.isValidMessage ="Please enter min "+ rules.minLength + " " + txtinfor
            return validObj;
        }

    }

    if ( rules.maxLength ) {
        if ( value.length <= rules.maxLength ){
            validObj.isValid =true
            return validObj;
        }else{
            validObj.isValid =false
            validObj.isValidMessage ="Please enter max "+ rules.maxLength + " character"
            return validObj;
        }

    }

    

    
    // console.log(validObj)
    // return validObj;
}
